import * as React from "react";
import { forwardRef } from "react";
const SvgModeSwitcher = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M12 1.5a10.5 10.5 0 1 1 0 21 10.5 10.5 0 0 1 0-21M12 21a9.003 9.003 0 0 0 9-9 9.003 9.003 0 0 0-9-9z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgModeSwitcher);
export default ForwardRef;
